/** Why someone was sent to the customer list, carried in router state and never in the URL. */
export const CUSTOMER_INTENT_EYE_EXAMINATIONS = 'eye-examinations';

/** Sent from the counter to choose whose optical order to take: it starts from that customer's profile. */
export const CUSTOMER_INTENT_OPTICAL_ORDER = 'optical-order';
